import { render, staticRenderFns } from "./FrontGroupDeviceCard.vue?vue&type=template&id=60f34cfb&scoped=true&"
import script from "./FrontGroupDeviceCard.vue?vue&type=script&lang=js&"
export * from "./FrontGroupDeviceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f34cfb",
  null
  
)

export default component.exports